<template>
    <div>
        <modal :show="showPolicies">
            <div style="background:white;margin:0 auto;width:80%;overflow-y:auto;height:80%;margin-top:50px;padding:20px;">
                <div style="text-align:right;"><span class="btn btn-default" @click="showPolicies=false">X</span></div>
                <policies :api-client="{getItemsPrms:apiClient.getPoliciesPrms}" v-if="showPolicies"></policies>
            </div>
        </modal>

        <modal-x :show="showContacts" @onclose="showContacts=false">
            <paged-contact v-on:onselect="onContactSelected" v-if="showContacts"></paged-contact>
        </modal-x>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div ref="container">
                <div style="width:100%;padding:5px;text-align:right;">
                    <span class="btn btn-default" style="float:left;" @click="loadItems">{{lang.common.refresh}}</span>
                    <span class="glyphicon glyphicon-chevron-right"></span>
                    <span class="btn btn-primary" @click="checkout"> {{lang.cart.submitOrder}} </span>
                </div>

                <div v-if="selectedContact!==null" style="border:4px solid gray;padding:4px;">
                    <div>
                        <div class="act-title" style="font-weight:bolder;text-align:right;color:gray;">
                            {{selectedContact.title}}({{selectedContact.id}})
                        </div>
                    </div>
                    <div class="act-detail" style="padding-left:10px;">
                        <span style="font-weight:bold;">{{lang.common.name}}:</span>{{selectedContact.name}} / <span style="font-weight:bold;">{{lang.common.phone}}:</span>{{selectedContact.phone}}
                    <div>
                        <div style="font-weight:bold;">{{lang.contact.deliveryAddress}}:</div>
                        {{selectedContact.address}}
                    </div>
                        <div v-if="selectedContact.pickContact!==null" style="padding-left:16px;">
                            <div class="label label-info"> {{lang.common.pickup}} </div>
                            <div>{{selectedContact.pickContact.title}}:{{selectedContact.pickContact.phone}}</div>
                            <div>{{selectedContact.pickContact.address}}</div>
                        </div>
                    </div>
                </div>

                <div v-for="grp in itemGroups" class="row" :data-shop-user-id="grp.shop.shopUserId" style="border:1px solid gray;">
                    <div class="col-xs-12">
                        <h3 class="agx-shop-name"> {{grp.shop.shopName}} <span style="color:gray;font-size:10px;"></span></h3>
                        <div>
                            <span class="btn btn-info" @click="showPolicies=true">{{lang.cart.terms}}</span>
                        </div>
                        <br>
                    </div>
                    <div v-for="item in grp.items" class="ags-carted-item">
                        <div class="row act-item-row" :item-data="item.id" style="margin:4px;">

                            <div class="col-md-3 col-xs-12 ags-carted-left-col">
                                <div style="background:white;width:100%;height:40px;">
                                    <span class="btn btn-default" style="float:left;" @click="removeCartItem(item)"> X </span>
                                </div>
                                <router-link :to="'/detail?postId='+item.postId" class="act-title">
                                    <img :src="item.post.thumbPath" title="missing image" class="act-thumb img-responsive" style="display:inline-block;max-height:100px;">
                                </router-link>
                            </div>
                            <div class="col-md-6 col-xs-6">
                                <div>
                                    <router-link :to="'/detail?postId='+item.postId" class="act-title">{{item.title}}</router-link>
                                </div>
                                <div class="act-props-descr">
                                    <span v-for="pc in item.propCats">
                                        {{pc.parent.name}}:{{pc.child.name}}
                                    </span>
                                </div>
                                <div><span :price-val="item.price" class="act-price"> ${{item.price}} </span>
                                <div><input class="form-control" type="text" :value="item.quant" style="width:50px;" @change="updateQuant(item,$event)"></div>
                                </div>
                            </div>

                            <div class="col-md-3 col-xs-6" style="text-align:right;display:none;">
                                <div style="width:40px;height:40px;line-height:40px;text-align:center;display:inline-block;" class="act-checkbox">
                                    <img src="/images/sys/tick.png" class="agx-icon-checked">
                                    <img src="/images/sys/tickhollo.png" class="agx-icon-unchecked">
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modal from './base/Modal.vue';
    import modalX from './base/ModalX1.vue'; 
    import policies from './Policies.vue';
    import pagedContact from './PagedContact.vue';
    import localCart from "../api/localCart.js";

    export default {
        components: {
            pagedLoading: pagedLoading,
            modal: modal,
            modalX: modalX,
            policies: policies,
            pagedContact: pagedContact
        },
        //props: ["apiClient", "userId"],
        data: function () {
            return {
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                itemGroups: [],
                showPolicies: false,
                showContacts: false,
                selectedContact: null
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.cartApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            addToAccountCart: function () {
                this.$router.push("cart");
            },
            updateQuant: function (item,event) {
                console.log('updateQuant val', event.target.value);
                item.quant = event.target.value;
                localCart.api.updateCartItem(item);
            },
            removeCartItem: function (item) {
                console.log("remove item:", item);
                localCart.api.removeItem(item.priceId);
                this.reloadItems();
            },
            onContactSelected: function (contact) {
                console.log("shipto", contact);
                this.selectedContact = contact;
                this.showContacts = false;
            },
            reloadItems: function () {
                var obj = { uid: this.userId };
                this.loadItems(queryString().getString(obj));
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                this.loadItems(queryString().getString(obj));
            },
            checkout: function () {
                //this.$store.commit("setShowLogin", true);
                this.mxnAgxShowLogin(true);
            },
            loadItems: function (query) {
                this.itemGroups = [];
                this.loadingImg = true;

                this.apiClient.setOnRemove((ret) => {
                    console.log("to delete:",ret);
                    /*
                    var itemIds = ret.itemIds;
                    if (ret.ok === true) {
                        for (var i = 0; i < itemIds.length; i++) {
                            var id = itemIds[i];
                            this.itemGroups.forEach((g) => {
                                g.items = g.items.filter((it) => { return it.id != id; });
                            });
                        }
                    }
                    */
                });

                //localCart items
                var lsCartObj = localCart.api.getCart();
                var localCartItems = lsCartObj.items;

                this.apiClient.getLocalCartItemsPrms(localCartItems).done((ret) => {
                    this.loadingImg = false;
                    var filter = ret.filter;
                    this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.itemGroups = ret.items;

                    this.$nextTick(() => {
                        this.apiClient.registerItem(this.$refs.container);
                    });

                }).fail((ret) => {
                    this.loadingImg = false;
                });
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.addToAccountCart);
            this.reloadItems();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.addToAccountCart);
        },
        mounted: function () {
            this.apiClient.pingPrms().then((ret) => {
                if (ret.hasLogin === true) {
                    this.addToAccountCart();
                }
            });
        }
    }
</script>